import { render, staticRenderFns } from "./PanelProduct.vue?vue&type=template&id=c4a2c2a2"
import script from "./PanelProduct.vue?vue&type=script&lang=js"
export * from "./PanelProduct.vue?vue&type=script&lang=js"
import style0 from "./PanelProduct.vue?vue&type=style&index=0&id=c4a2c2a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports